exports.default = {
  'invitation_code': '邀請碼',
  'enter_invitation_code': '請填寫邀請碼',
  'join_team_applied': '您已成功申請加入團隊！等待管理員審核後將加入團隊',
  'join_team_success': '您已成功加入團隊！',
  'join_team_invitation': '團隊邀請',
  'join_team_title_fallback': '加入團隊',
  'join_team_invited_by': '{name} 邀請你加入團隊',
  'join_team_invited_default': '你的同事邀請你加入團隊',
  'join_team_visual_note': '與團隊成員在 PAITEAMS 中協作，共同推進工作。',
  'join_team_invalid_title': '邀請連結已失效',
  'join_team_invalid_description': '該邀請可能已過期、被重置或對應團隊不可用，請聯絡邀請人取得新連結。',
  'join_team_return_home': '返回首頁',
  'join_team_heading': '加入 {team}',
  'join_team_already_member_title': '你已在該團隊中',
  'join_team_already_member_description': '無需再次驗證，可以直接返回 {team}。',
  'join_team_back_to_team': '回到團隊',
  'join_team_current_account': '目前帳號',
  'join_team_current_user': '目前使用者',
  'join_team_verified': '已驗證',
  'join_team_verification_method': '驗證方式',
  'join_team_phone_verification': '手機驗證',
  'join_team_email_verification': '電子郵件驗證',
  'join_team_real_name_optional': '姓名（選填）',
  'join_team_agreement_prefix': '我已閱讀並同意',
  'join_team_joining': '正在加入...',
  'join_team_logged_in_description': '確認帳號資訊後即可加入，無需再次驗證。',
  'join_team_verify_description': '驗證你的帳號後，即可接受這次團隊邀請。',
  'join_team_failed': '加入團隊失敗，請稍後再試',
  'team_name': '團隊名稱',
  'enter_team_name': '請輸入團隊名稱',
  'industry': '所屬行業',
  'company_size': '公司規模',
  'select_company_size': '請選擇公司規模',
  'team_name_required': '請輸入公司名稱',
  'team_name_length': '公司名稱長度應大於3個字符小於100字符',
  'industry_required': '請選擇行業',
  'size_required': '請選擇公司人數',
  'size_1_10': '1~10人',
  'size_11_50': '11~50人',
  'size_51_100': '51~100人',
  'size_101_300': '101~300人',
  'size_301_1000': '301~1000人',
  'size_1001_plus': '1001人及以上',
  'team_created': '團隊創建成功！',
  'qrcode_invitation': '二維碼邀請',
  'link_invitation': '鏈接邀請',
  'mobile_invitation': '手機邀請',
  'mobile_phone': '手機號碼',
  'enter_your_mobile_phone_number': '請輸入手機號碼',
  'copy': '複製',
  'copy_succeeded': '複製成功',
  'team_as_soon_as_possible3': '團隊邀請發送成功',
  'please_fill_in_the_invitation_form': '請填寫邀請表單',
  'please_fill_in_the_invitation_email': '請填寫邀請郵箱',
  'please_enter_your_mobile_number': '請輸入手機號碼',
  'the_correct_mobile_phone_number': '請輸入正確的手機號碼',
  'invitation_expiry_time': '邀請方式失效時間：',
  'reset': '重置',
  'please_enter_your_real_name': '請輸入您的真實姓名',
  'join_now': '立即加入',
  'service_agreement': '服務協議',
  'privacy_policy': '《隱私政策》',
  'agreement_consent_text': '點擊立即加入代表你已閱讀並同意',
  'invalid_phone': '請輸入合法的手機號',
  'team_management': '團隊管理',
  'edit_avatar': '修改頭像',
  'nickname': '暱稱',
  'modify_nickname': '修改暱稱',
  'phone': '手機',
  'rebind': '重新綁定',
  'password': '密碼',
  'reset_password': '重置密碼',
  'crop_image': '裁剪圖片',
  'crop_image_question': '是否需要裁剪圖片？',
  'crop': '裁剪',
  'upload_without_crop': '不裁剪直接上傳',
  'upload_image': '上傳圖片',
  'cancel': '取 消',
  'confirm': '確 定',
  'verification_code': '驗證碼',
  'next_step': '下一步',
  'new_password': '新密碼',
  'confirm_password': '確認密碼',
  'enter_new_password': '請輸入新密碼',
  'confirm_new_password_again': '請再次輸入新密碼',
  'confirm_modification': '確認修改',
  'enter_mobile_number': '請輸入手機號碼',
  'enter_verification_code': '請輸入驗證碼',
  'get_verification_code': '獲取驗證碼',
  'input_nickname': '請輸入暱稱',
  'old_phone_number': '舊手機號',
  'new_phone_number': '新手機號',
  'please_enter_nickname': '請修改您的暱稱',
  'save_success': '保存成功！',
  'and': '和',
  'image_type_error': '圖片類型必須是.gif,jpeg,jpg,png,bmp中的一種',
  'verification_code_sent': '獲取短信驗證碼成功，請留意您的短信',
  'verification_code_empty': '獲取驗證碼手機號不能為空',
  'verification_failed': '驗證碼校驗失敗',
  'check_account_verification': '請檢查賬號驗證碼是否填寫正確',
  'password_reset_success': '密碼已重置！請重新登錄！',
  'enter_new_password': '請填寫新密碼',
  'phone_reset_success': '手機已重置！請重新登錄！',
  'bind_phone_first': '您還未綁定手機，請先進行手機綁定！',
  'password_requirements': '必須包含大小寫字母數字，至少8個字符',
  'password_confirmation': '請再次確認密碼',
  'password_mismatch': '請保持兩次密碼一致!',
  'phone_required': '手機號不能為空',
  'phone_invalid': '請輸入正確的手機號',
  '6_digit_verification_code': '請輸入6位驗證碼'
}
